import { StringRenderer, mapRenderer } from "../shared/renderers/table";
import { getProtoTimestampAsDateStringSecond } from "../shared/utils";
import { IntlShape } from "react-intl";
import { TableColumns } from "../shared/crud/list";
import { CustomBundle } from ".";
import { getLanguageFromFullLocale } from "../../lib/config";
import { BundlePriceType } from "./EditBundle/types";
import { BUNDLE_TYPE_MESSAGE, messages } from "./EditBundle/messages";
import { tableHeaderMessages } from "./messages";

export default function getTableColumns(intl: IntlShape): TableColumns<CustomBundle> {
  return {
    active: {
      renderer: mapRenderer(StringRenderer, (v, _) => {
        return v
          ? intl.formatMessage(tableHeaderMessages.activeValue).toString()
          : intl.formatMessage(tableHeaderMessages.inactiveValue).toString();
      }),
    },
    ticker: {
      renderer: StringRenderer,
    },
    translationsList: {
      children: {
        name: {
          renderer: mapRenderer(StringRenderer, (v, intl) => {
            if (!v || !v.length) return undefined;
            const current = v.find(t => t.locale === getLanguageFromFullLocale(intl.locale));
            return current?.name || v[0].name;
          }),
        },
      },
    },
    bundlePriceType: {
      renderer: mapRenderer(StringRenderer, (v, intl) => {
        //@ts-ignore
        const current = BUNDLE_TYPE_MESSAGE[BundlePriceType[v]];
        return intl.formatMessage(current.label).toString();
      }),
    },
    promotionsList: {
      renderer: mapRenderer(StringRenderer, (v, _) => {
        if (!v || !v.length) {
          return undefined;
        }
        return v.toString();
      }),
    },
    extrasList: {
      renderer: mapRenderer(StringRenderer, (v, _) => {
        if (!v || !v.length) {
          return undefined;
        }
        return v.toString();
      }),
    },

    travelWindowsList: {
      renderer: mapRenderer(StringRenderer, (v, _) => {
        if (!v || !v.length) {
          return undefined;
        }

        if (v.length > 1) {
          return intl.formatMessage(messages.multiple).toString();
        }

        const startDate = getProtoTimestampAsDateStringSecond(v[0]?.startDate);
        const endDate = getProtoTimestampAsDateStringSecond(v[0]?.endDate);
        return `${startDate} - ${endDate}`;
      }),
    },
    codesList: {
      renderer: mapRenderer(StringRenderer, (v, _) => {
        if (!v || !v.length) {
          return undefined;
        }
        return v.toString();
      }),
    },
  };
}
